export const getCampaign = state => (
  state.campaign
);

export const getError = state => (
  state.error
);

export const getCustomer = state => (
  state.order.customer
);

export const getOrderLoading = state => (
  state.order.loading
);

export const getOffers = state => (
  state.campaign.offers
);

export const getOrder = state => (
  state.order
);

export const getOrderPrice = (state) => {
  let amount = 0;
  amount += state.order.campaign.price_incl_vat * state.order.quantity;
  state.order.offers.forEach((offer) => {
    amount += offer.price_incl_vat * offer.quantity;
  });
  return amount;
};
